"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KW_COURT = exports.patterns = void 0;
exports.isLeapYear = isLeapYear;
exports.createPasswordPattern = createPasswordPattern;
exports.date = date;
exports.time = time;
exports.kod = kod;
exports.date_time = date_time;
exports.hostname = hostname;
exports.uri = uri;
exports.url = url;
exports.uuid = uuid;
exports.ipv4 = ipv4;
exports.ipv6 = ipv6;
exports.regex = regex;
exports.nip = nip;
exports.kw = kw;
exports.pesel = pesel;
exports.regon9 = regon9;
exports.regon14 = regon14;
exports.regon = regon;
exports.iban = iban;
exports.dowod = dowod;
exports.edowod = edowod;
exports.email = email;
exports.guid = guid;
exports.guidlong = guidlong;
exports.guidshort = guidshort;
exports.numeric = numeric;
exports.phone9 = phone9;
exports.phone = phone;
exports.passport = passport;
exports.checkFormat = checkFormat;
exports.checkFormatFunction = checkFormatFunction;
exports.patterns = {
    DATE0: /^(\d\d\d\d)-(\d\d)-(\d\d)([t|T|\s](00:00:00))?$/,
    TIME: /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i,
    /**
     * kod pocztowy: 76-200
     */
    KOD_POCZTOWY: /^[0-9]{2}-[0-9]{3}$/,
    HOSTNAME: /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*$/i,
    NOT_URI_FRAGMENT: /\/|:/,
    URI: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // eslint-disable-next-line no-control-regex
    URL: /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i,
    UUID: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    IPv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    IPv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    Z_ANCHOR: /[^\\]\\Z/,
    /**
     * numer konta bankowego, np. PL61109010140000071219812874 lub PL61 1090 1014 0000 0712 1981 2874, 61 1090 1014 0000 0712 1981 2874
     */
    IBAN: /^([A-Z]{2}[ ]?)?[0-9][0-9]([ ]?[0-9]{4}){6}$/,
    EMAIL: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    /**
     * guid z kreskami
     */
    GUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
    /**
     * guid skrócony
     */
    GUID12: /^[0-9a-f]{12}$/i,
    /**
     * liczba
     */
    NUMERIC: /^\d+$/,
    /**
     * numer 9 cyfrowy
     */
    PHONE9: /^\d{9}$/,
    PHONE: /^\d{9}$/,
    DOWOD: /^[A-Z]{3}[ ]{0,1}\d{6}$/,
    EDOWOD: /^[A-Z]{4}[ ]{0,1}\d{5}$/,
    PASSPORT: /^[A-Z]{2}[ ]{0,1}\d{6}$/,
    NIP: /^(\d{10}|\d{3}-\d{3}-\d{2}-\d{2}|\d{3}-\d{2}-\d{2}-\d{3})$/,
    NIP_NUMBERSONLY: /^\d{10}$/,
    KW: /^[A-Z0-9]{1,4}\/\d{1,6}\/\d$/,
    PESEL: /^\d{11}$/,
    LCASE_UCASE_NUMBER_SPECIAL_8PLUS: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9])(?=.{8,})$/
};
const MONTH_DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
/**
 * czy rok jest przestępny
 *
 * @param {number} year
 * @returns {boolean}
 */
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
/**
 * tworzy wzorzec dla hasła
 * @param options opcje hasła
 * @returns
 */
function createPasswordPattern(options) {
    let pattern = '';
    if (options.requireLowercase) {
        pattern += '(?=.*[a-z])';
    }
    if (options.requireUppercase) {
        pattern += '(?=.*[A-Z])';
    }
    if (options.requireNumber) {
        pattern += '(?=.*[0-9])';
    }
    if (options.requireSpecial) {
        // pattern += '\\W';
        pattern += '(?=.*[^a-zA-Z0-9])';
    }
    pattern += `(.{${options.minLength || 0},${options.maxLength || ''}})`;
    return new RegExp(`^${pattern}$`);
}
/**
 * data yyyy-MM-dd, lub yyyy-MM-dd 00:00:00
 * sprawdza również czy data jest prawidłowa, wraz ze sprawdzaniem roku przestępnego
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function date(str) {
    // dopuszcony jest zerowy czas 00:00:00
    const matches = str.match(exports.patterns.DATE0);
    if (!matches) {
        return false;
    }
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && isLeapYear(year) ? 29 : MONTH_DAYS[month]);
}
/**
 * czas HH:m:ss
 *
 * @export
 * @param {string} str
 * @param {boolean} [full] czy wymagana jest strea czasowa
 * @returns {boolean}
 */
function time(str, full) {
    const matches = str.match(exports.patterns.TIME);
    if (!matches) {
        return false;
    }
    const hour = Number(matches[1]);
    const minute = Number(matches[2]);
    const second = Number(matches[3]);
    const timeZone = matches[5];
    return (((hour <= 23 && minute <= 59 && second <= 59) || (hour === 23 && minute === 59 && second === 60)) &&
        (!full || timeZone !== ''));
}
/**
 * kod pocztowy: 76-200
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function kod(str) {
    return exports.patterns.KOD_POCZTOWY.test(str);
}
const DATE_TIME_SEPARATOR = /t|\s/i;
/**
 * data z czasem, yyyy-MM-dd HH:mm:ss
 * mogą być rozdzielone `t` lub ` `
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    const dateTime = str.split(DATE_TIME_SEPARATOR);
    return dateTime.length === 2 && date(dateTime[0]) && time(dateTime[1], true);
}
/**
 * host np. server.domena.pl
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function hostname(str) {
    return str.length <= 255 && exports.patterns.HOSTNAME.test(str);
}
/**
 * URI, np. file://xvxvx
 *
 * @export
 * @param {string} str
 * @returns
 */
function uri(str) {
    return exports.patterns.NOT_URI_FRAGMENT.test(str) && exports.patterns.URI.test(str);
}
/**
 * URL, np. https://google.com
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function url(str) {
    return exports.patterns.URL.test(str);
}
/**
 * UUID
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function uuid(str) {
    return exports.patterns.UUID.test(str);
}
/**
 * IP4: 192.168.23.4
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function ipv4(str) {
    return exports.patterns.IPv4.test(str);
}
/**
 * IP6: 2001:0db8:85a3:0000:0000:8a2e:0370:7334
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function ipv6(str) {
    return exports.patterns.IPv6.test(str);
}
/**
 * RegEx
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function regex(str) {
    if (exports.patterns.Z_ANCHOR.test(str)) {
        return false;
    }
    try {
        // new RegExp(str);
        // eslint-disable-next-line no-constant-binary-expression
        return new RegExp(str) !== null;
    }
    catch (_a) {
        return false;
    }
}
const NIP_WEIGHTS = [6, 5, 7, 2, 3, 4, 5, 6, 7];
/**
 * NIP: 9570716562
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function nip(str) {
    str = str.replace(/[\s-]/g, '');
    if (str.length === 10) {
        let sum = 0;
        for (let i = 0; i < 9; i++) {
            const val = Number(str[i]);
            if (!isNaN(val)) {
                sum += val * NIP_WEIGHTS[i];
            }
        }
        return sum % 11 === Number(str[9]);
    }
    return false;
}
/**
 * obiekt zawierający wszystkie symbole sądów
 */
exports.KW_COURT = {
    WL1A: 'Aleksandrów Kujawski',
    SU1A: 'Augustów',
    OL1Y: 'Bartoszyce',
    PT1B: 'Bełchatów',
    KA1B: 'Będzin',
    LU1B: 'Biała podlaska',
    RA2G: 'Białobrzegi',
    KO1B: 'Białogard',
    BI1B: 'Białystok',
    BB1B: 'Bielsko-Biała',
    BI1P: 'Bielsk Podlaski',
    ZA1B: 'Biłgoraj',
    OL1B: 'Biskupiec',
    TR1O: 'BochniaR1O',
    JG1B: 'Bolesławiec',
    EL1B: 'Braniewo',
    TO1B: 'Brodnica',
    OP1B: 'Brzeg',
    TR1B: 'Brzesko',
    LD1B: 'Brzeziny',
    KS1B: 'Brzozów',
    KI1B: 'Busko Zdrój',
    BY1B: 'Bydgoszcz',
    KA1Y: 'Bytom',
    SL1B: 'Bytów',
    LU1C: 'Chełm',
    TO1C: 'Chełmno',
    PO1H: 'Chodzież',
    SL1C: 'Chojnice',
    KA1C: 'Chorzów',
    SZ1C: 'Choszczno',
    KR1C: 'Chrzanów',
    PL1C: 'Ciechanów',
    BB1C: 'Cieszyn',
    PO2T: 'Czarnków',
    KR1K: 'Czernichów',
    CZ1C: 'Częstochowa',
    SL1Z: 'Człuchów',
    KA1D: 'Dąbrowa Górnicza',
    TR1D: 'Dąbrowa Tarnowska',
    RZ1D: 'Dębica',
    KR2Y: 'Dobczyce',
    KO1D: 'Drawsko Pomorskie',
    EL1D: 'Działdowo',
    SW1D: 'Dzierżoniów',
    EL1E: 'Elbląg',
    OL1E: 'Ełk',
    SI1G: 'Garwolin',
    GD1G: 'Gdańsk',
    GD1Y: 'Gdynia',
    OL1G: 'Giżycko',
    GL1G: 'Gliwice',
    LE1G: 'Głogów',
    OP1G: 'Głubczyce',
    PO1G: 'Gniezno',
    SZ1O: 'Goleniów',
    TO1G: 'Golub-Dobrzyń',
    NS1G: 'Gorlice',
    GW1G: 'Gorzów Wielkopolski',
    PL1G: 'Gostynin',
    PO1Y: 'Gostyń',
    LM1G: 'Grajewo',
    WA1G: 'Grodzisk Mazowiecki',
    PO1S: 'Grodzisk Wlkp.',
    RA1G: 'Grójec',
    TO1U: 'Grudziądz',
    SZ1G: 'Gryfice',
    SZ1Y: 'Gryfino',
    ZG2K: 'Gubin',
    BI2P: 'Hajnówka',
    ZA1H: 'Hrubieszów',
    EL1I: 'Iława',
    BY1I: 'Inowrocław',
    ZA1J: 'Janów Lubelski',
    KZ1J: 'Jarocin',
    PR1J: 'Jarosław',
    KS1J: 'Jasło',
    GL1J: 'Jastrzębie-Zdrój',
    LE1J: 'Jawor',
    KA1J: 'Jaworzno',
    JG1J: 'Jelenia Góra',
    KI1J: 'Jędrzejów',
    KZ1A: 'Kalisz',
    JG1K: 'Kamienna Góra',
    SZ1K: 'Kamień Pomorski',
    GD1R: 'Kartuzy',
    KA1K: 'Katowice',
    KI1I: 'Kazimierza wielka',
    OP1K: 'Kędzierzyn-koźle',
    KZ1E: 'Kępno',
    OL1K: 'Kętrzyn',
    KR2E: 'Kęty',
    KI1L: 'Kielce',
    OP1U: 'Kluczbork',
    CZ2C: 'Kłobuck',
    SW1K: 'Kłodzko',
    TB1K: 'Kolbuszowa',
    KO1L: 'Kołobrzeg',
    KN1K: 'Koło',
    KN1N: 'Konin',
    KI1K: 'Końskie',
    KO1K: 'Koszalin',
    PO1K: 'Kościan',
    GD1E: 'Kościerzyna',
    RA1K: 'Kozienice',
    KR1P: 'Kraków',
    ZA1K: 'Krasnystaw',
    LU1K: 'Kraśnik',
    KS1K: 'Krosno',
    ZG1K: 'Krosno Odrzańskie',
    KZ1R: 'Krotoszyn',
    KR2K: 'Krzeszowice',
    LD1K: 'Kutno',
    GD1I: 'Kwidzyn',
    WA1L: 'Legionowo',
    LE1L: 'Legnica',
    KS1E: 'Lesko',
    PO1L: 'Leszno',
    RZ1E: 'Leżajsk',
    SL1L: 'Lębork',
    OL1L: 'Lidzbark Warmiński',
    NS1L: 'Limanowa',
    WL1L: 'Lipno',
    RA1L: 'Lipsko',
    PR1L: 'Lubaczów',
    JG1L: 'Lubań',
    LU1A: 'Lubartów',
    LE1U: 'Lubin',
    CZ1L: 'Lubliniec',
    LU1I: 'Lublin',
    JG1S: 'Lwówek Śląski',
    RZ1A: 'Łańcut',
    SR1L: 'Łask',
    LD1Y: 'Łęczyca',
    SZ1L: 'Łobez',
    LM1L: 'Łomża',
    SI2S: 'Łosice',
    LD1O: 'Łowicz',
    LD1M: 'Łódź',
    LU1U: 'Łuków',
    GD1M: 'Malbork',
    SL1M: 'Miastko',
    KR1M: 'Miechów',
    TB1M: 'Mielec',
    PO2A: 'Międzychód',
    GW1M: 'Międzyrzecz',
    KA1M: 'Mikołów',
    WR1M: 'Milicz',
    SI1M: 'Mińsk Mazowiecki',
    PL1M: 'Mława',
    BY1M: 'Mogilno',
    EL2O: 'Morąg',
    OL1M: 'Mrągowo',
    NS2L: 'Mszana Dolna',
    NS1M: 'Muszyna',
    KA1L: 'Mysłowice',
    CZ1M: 'Myszków',
    KR1Y: 'Myślenice',
    SZ1M: 'Myślibórz',
    BY1N: 'Nakło nad Notecią',
    OL1N: 'Nidzica',
    KR2I: 'Niepołomice',
    TB1N: 'Nisko',
    SW2K: 'Nowa Ruda',
    ZG1N: 'Nowa Sól',
    EL1N: 'Nowe Miasto Lubawskie',
    GD2M: 'Nowy Dwór Gdański',
    WA1N: 'Nowy Dwór Mazowiecki',
    NS1S: 'Nowy Sącz',
    NS1T: 'Nowy Targ',
    PO1N: 'Nowy Tomyśl',
    OP1N: 'Nysa',
    PO1O: 'Oborniki',
    OL1C: 'Olecko',
    OP1L: 'Olesno',
    WR1E: 'Oleśnica',
    KR1O: 'Olkusz',
    OL1O: 'Olsztyn',
    WR1O: 'Oława',
    KI1T: 'Opatów',
    PT1O: 'Opoczno',
    LU1O: 'Opole Lubelskie',
    OP1O: 'Opole',
    OS1O: 'Ostrołęka',
    KI1O: 'Ostrowiec Świętokrzyski',
    EL1O: 'Ostróda',
    OS1M: 'Ostrów Mazowiecka',
    KZ1W: 'Ostrów Wielkopolski',
    KZ1O: 'Ostrzeszów',
    KR1E: 'Oświęcim',
    WA1O: 'Otwock',
    LD1P: 'Pabianice',
    SR2W: 'Pajęczno',
    WA1I: 'Piaseczno',
    PO1I: 'Piła',
    KI1P: 'Pińczów',
    RA2Z: 'Pionki',
    PT1P: 'Piotrków Trybunalski',
    OL1P: 'Pisz',
    KZ1P: 'Pleszew',
    PL1P: 'Płock',
    PL1L: 'Płońsk',
    SR2L: 'Poddębice',
    SZ2S: 'Police',
    PO1P: 'Poznań (V)',
    PO2P: 'Poznań (VI)',
    KR1H: 'Proszowice',
    OP1P: 'Prudnik',
    WA1P: 'Pruszków',
    OS1P: 'Przasnysz',
    PR1P: 'Przemyśl',
    PR1R: 'Przeworsk',
    RA1P: 'Przysucha',
    KA1P: 'Pszczyna',
    GD2W: 'Puck',
    LU1P: 'Puławy',
    OS1U: 'Pułtusk',
    SZ2T: 'Pyrzyce',
    GL1R: 'Racibórz',
    RA1R: 'Radom',
    PT1R: 'Radomsko',
    WL1R: 'Radziejów',
    LU1R: 'Radzyń Podlaski',
    LD1R: 'Rawa Mazowiecka',
    PO1R: 'Rawicz',
    RZ1R: 'Ropczyce',
    GL1S: 'Ruda Śląska',
    GL1Y: 'Rybnik',
    LU1Y: 'Ryki',
    WL1Y: 'Rypin',
    RZ1Z: 'Rzeszów',
    KI1S: 'Sandomierz',
    KS1S: 'Sanok',
    SU1N: 'Sejny',
    BY2T: 'Sępólno Krajeńskie',
    SI1S: 'Siedlce',
    KA1I: 'Siemianowice Śląskie',
    BI3P: 'Siemiatycze',
    PR2R: 'Sieniawa',
    SR1S: 'Sieradz',
    PL1E: 'Sierpc',
    KR2P: 'Skała',
    KI1R: 'Skarżysko-Kamienna',
    KR3I: 'Skawina',
    LD1H: 'Skierniewice',
    KO1E: 'Sławno',
    KR1S: 'Słomniki',
    GW1S: 'Słubice',
    KN1S: 'Słupca',
    SL1S: 'Słupsk',
    PL1O: 'Sochaczew',
    SI1P: 'Sokołów Podlaski',
    BI1S: 'Sokółka',
    GD1S: 'Sopot',
    KA1S: 'Sosnowiec',
    TB1S: 'Stalowa Wola',
    KI1H: 'Starachowice',
    SZ1T: 'Stargard Szczeciński',
    GD1A: 'Starogard Gdański',
    KI1A: 'Staszów',
    GW1K: 'Strzelce Krajeńskie',
    OP1S: 'Strzelce Opolskie',
    WR1T: 'Strzelin',
    RZ1S: 'Strzyżów',
    KR1B: 'Sucha Beskidzka',
    ZG2S: 'Sulechów',
    GW1U: 'Sulęcin',
    SU1S: 'Suwałki',
    PO1A: 'Szamotuły',
    KO1I: 'Szczecinek',
    SZ1S: 'Szczecin',
    OL1S: 'Szczytno',
    GD2I: 'Sztum',
    BY1U: 'Szubin',
    RA1S: 'Szydłowiec',
    PO1M: 'Śrem',
    WR1S: 'Środa Śląska',
    PO1D: 'Środa Wlkp.',
    SW1S: 'Świdnica',
    KO2B: 'Świdwin',
    ZG1S: 'Świebodzin',
    BY1S: 'Świecie',
    SZ1W: 'Świnoujście',
    TB1T: 'Tarnobrzeg',
    GL1T: 'Tarnowskie Góry',
    TR1T: 'Tarnów',
    GD1T: 'Tczew',
    ZA1T: 'Tomaszów Lubelski',
    PT1T: 'Tomaszów Mazowiecki',
    TO1T: 'Toruń',
    PO1T: 'Trzcianka',
    WR1W: 'Trzebnica',
    BY1T: 'Tuchola',
    TR2T: 'Tuchów',
    KN1T: 'Turek',
    KA1T: 'Tychy',
    RZ2Z: 'Tyczyn',
    KS2E: 'Ustrzyki Dolne',
    KR1W: 'Wadowice',
    SW1W: 'Wałbrzych',
    KO1W: 'Wałcz',
    WA3M: 'Warszawa (IX)',
    WA1M: 'Warszawa (VI)',
    WA2M: 'Warszawa (VII)',
    WA4M: 'Warszawa (X)',
    WA5M: 'Warszawa (XIII)',
    WA6M: 'Warszawa (XV)',
    TO1W: 'Wąbrzeźno',
    PO1B: 'Wągrowiec',
    GD1W: 'Wejherowo',
    OL2G: 'Węgorzewo',
    SI1W: 'Węgrów',
    KR1I: 'Wieliczka',
    SR1W: 'Wieluń',
    WL1W: 'Włocławek',
    LU1W: 'Włodawa',
    KI1W: 'Włoszczowa',
    GL1W: 'Wodzisław Śląski',
    PO1E: 'Wolsztyn',
    WA1W: 'Wołomin',
    WR1L: 'Wołów',
    WR1K: 'Wrocław',
    PO1F: 'Września',
    ZG1W: 'Wschowa',
    PO2H: 'Wyrzysk',
    LM1W: 'Wysokie Mazowieckie',
    OS1W: 'Wyszków',
    GL1Z: 'Zabrze',
    NS1Z: 'Zakopane',
    LM1Z: 'Zambrów',
    ZA1Z: 'Zamość',
    CZ1Z: 'Zawiercie',
    SW1Z: 'Ząbkowice Śląskie',
    SR1Z: 'Zduńska Wola',
    LD1G: 'Zgierz',
    JG1Z: 'Zgorzelec',
    ZG1E: 'Zielona Góra',
    LE1Z: 'Złotoryja',
    PO1Z: 'Złotów',
    RA1Z: 'Zwoleń',
    ZG1G: 'Żagań',
    ZG1R: 'Żary',
    BY1Z: 'Żnin',
    GL1X: 'Żory',
    PL2M: 'Żuromin',
    PL1Z: 'Żyrardów',
    BB1Z: 'Żywiec'
};
/**
 * obiekt zawierający wartości poszczegółnych znaków
 */
const KW_LETTER_VALUES = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    X: 10,
    A: 11,
    B: 12,
    C: 13,
    D: 14,
    E: 15,
    F: 16,
    G: 17,
    H: 18,
    I: 19,
    J: 20,
    K: 21,
    L: 22,
    M: 23,
    N: 24,
    O: 25,
    P: 26,
    R: 27,
    S: 28,
    T: 29,
    U: 30,
    W: 31,
    Y: 32,
    Z: 33
};
/**
 * numer księgi wieczystej: GD1G/00000125/6
 *
 * @export
 * @param {string} str
 * @returns
 */
function kw(str) {
    if (str == null)
        return false;
    if (str.length !== 15)
        return false;
    str = str.toUpperCase();
    // sprawdza slashe
    if (str[4] !== '/' || str[13] !== '/')
        return false;
    // sprawdza czy symbol sądu jest prawidłowy
    if (exports.KW_COURT[str.substring(0, 4)] === undefined) {
        return false;
    }
    // sprawdzanie czy w środku jest na pewno liczba
    if (isNaN(+str.substring(5, 13))) {
        return false;
    }
    // obliczanie sumy kontolnej
    const sum = 1 * (KW_LETTER_VALUES[str[0]] || 0) +
        3 * (KW_LETTER_VALUES[str[1]] || 0) +
        7 * (KW_LETTER_VALUES[str[2]] || 0) +
        1 * (KW_LETTER_VALUES[str[3]] || 0) +
        3 * (KW_LETTER_VALUES[str[5]] || 0) +
        7 * (KW_LETTER_VALUES[str[6]] || 0) +
        1 * (KW_LETTER_VALUES[str[7]] || 0) +
        3 * (KW_LETTER_VALUES[str[8]] || 0) +
        7 * (KW_LETTER_VALUES[str[9]] || 0) +
        1 * (KW_LETTER_VALUES[str[10]] || 0) +
        3 * (KW_LETTER_VALUES[str[11]] || 0) +
        7 * (KW_LETTER_VALUES[str[12]] || 0);
    // jeśli suma kontrolna jest różna sumie modulo 10 to numer jest nieprawidłowy
    if (+str[14] !== sum % 10)
        return false;
    return true;
}
const PESEL_WEIGHTS = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7];
/**
 * PESEL: 77010904673
 *
 * @export
 * @param {string} str
 * @returns
 */
function pesel(str) {
    str = str.replace(/[\s-]/g, '');
    if (str.length === 11) {
        if (allCharactersSame(str)) {
            return false;
        }
        let sum = 0;
        for (let i = 0; i < 10; i++) {
            const val = Number(str[i]);
            if (!isNaN(val)) {
                sum += val * PESEL_WEIGHTS[i];
            }
        }
        return sum % 10 === Number(str[10]);
    }
    return false;
}
/**
 * Sprawdza czy wszystkie znaki są takie same
 *
 * @param {string} str
 * @returns {boolean}
 */
function allCharactersSame(str) {
    if (typeof str !== 'string') {
        return false;
    }
    for (let i = 1; i < str.length; i++) {
        if (str[i] !== str[0]) {
            return false;
        }
    }
    return true;
}
const REGON9_WEIGHTS = [8, 9, 2, 3, 4, 5, 6, 7];
/**
 * regon (9 znakowy): 220318890
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function regon9(str) {
    if (str.length === 9) {
        let sum = 0;
        for (let i = 0; i < 8; i++) {
            const val = Number(str[i]);
            if (!isNaN(val)) {
                sum += val * REGON9_WEIGHTS[i];
            }
        }
        let mod = sum % 11;
        if (mod === 10) {
            mod = 0;
        }
        return mod === Number(str[8]);
    }
    return false;
}
const REGON14_WEIGHTS = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];
/**
 * regon (14 znakowy)
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function regon14(str) {
    // if ((regon.length == 14) && (parseInt(regon, 14) > 0)) {
    if (str.length === 14) {
        // czy regon konczy sie na 5 zer ? jesli tak to sprawdz go jako 9 elementowy
        if (str.endsWith('00000')) {
            return regon9(str.substring(0, 9));
        }
        let sum = 0;
        for (let i = 0; i < 13; i++) {
            const val = Number(str[i]);
            if (!isNaN(val)) {
                sum += val * REGON14_WEIGHTS[i];
            }
        }
        let mod = sum % 11;
        if (mod === 10) {
            mod = 0;
        }
        return mod === Number(str[13]);
    }
    return false;
}
/**
 * regon, sprawdza zarówno wersje 9 oraz 14 znakową
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function regon(str) {
    return str.length === 9 ? regon9(str) : regon14(str);
}
const IBAN_WEIGHTS = [
    1, 10, 3, 30, 9, 90, 27, 76, 81, 34, 49, 5, 50, 15, 53, 45, 62, 38, 89, 17, 73, 51, 25, 56, 75, 71, 31, 19, 93, 57
];
/**
 * numer rachunku w postaci IBAN (26 znaków, moga być ze spacjami)
 * 67 1140 2004 0000 3602 1050 8845
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function iban(str) {
    if (str === '00000000000000000000000000') {
        return true;
    }
    str = str.replace(/[^0-9]+/g, '');
    if (str.length === 26) {
        str = str + '2521';
        str = str.substring(2) + str.substring(0, 2);
        let Z = 0;
        for (let i = 0; i < 30; i++) {
            Z += Number(str[29 - i]) * IBAN_WEIGHTS[i];
        }
        if (Z % 97 === 1) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}
const LETTER_VALUES = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    G: 16,
    H: 17,
    I: 18,
    J: 19,
    K: 20,
    L: 21,
    M: 22,
    N: 23,
    O: 24,
    P: 25,
    Q: 26,
    R: 27,
    S: 28,
    T: 29,
    U: 30,
    V: 31,
    W: 32,
    X: 33,
    Y: 34,
    Z: 35
};
/**
 * seria i numer dowodu: AVG793448
 *
 * @export
 * @param {string} str
 * @returns
 */
function dowod(str) {
    str = str.replace(/[\s-]/g, '');
    // var numer = value.trim().replace(" ", "").replace("-", "");
    // Check length
    if (str == null || str.length !== 9) {
        return false;
    }
    str = str.toUpperCase();
    if (LETTER_VALUES[str[3]] >= 10)
        return edowod(str);
    // Check seria
    for (let i = 0; i < 3; i++) {
        if (LETTER_VALUES[str[i]] < 10) {
            return false;
        }
    }
    // Check number
    for (let i = 3; i < 9; i++) {
        const glv = LETTER_VALUES[str[i]];
        if (glv === undefined || glv < 0 || glv > 9) {
            return false;
        }
    }
    // sprawdz cyfre controlna
    let sum = 7 * LETTER_VALUES[str[0]] +
        3 * LETTER_VALUES[str[1]] +
        1 * LETTER_VALUES[str[2]] +
        7 * LETTER_VALUES[str[4]] +
        3 * LETTER_VALUES[str[5]] +
        1 * LETTER_VALUES[str[6]] +
        7 * LETTER_VALUES[str[7]] +
        3 * LETTER_VALUES[str[8]];
    sum %= 10;
    if (sum !== LETTER_VALUES[str[3]]) {
        return false;
    }
    return true;
}
/**
 * seria i numer edowodu: MACU27728
 *
 * @export
 * @param {string} str
 * @returns
 */
function edowod(str) {
    str = str.replace(/[\s-]/g, '');
    // var numer = value.trim().replace(" ", "").replace("-", "");
    // Check length
    if (str == null || str.length !== 9) {
        return false;
    }
    str = str.toUpperCase();
    // Check seria
    for (let i = 0; i < 4; i++) {
        if (LETTER_VALUES[str[i]] < 10) {
            return false;
        }
    }
    // Check number
    for (let i = 4; i < 9; i++) {
        const glv = LETTER_VALUES[str[i]];
        if (glv === undefined || glv < 0 || glv > 9) {
            return false;
        }
    }
    // sprawdz cyfre controlna
    let sum = 7 * LETTER_VALUES[str[0]] +
        3 * LETTER_VALUES[str[1]] +
        1 * LETTER_VALUES[str[2]] +
        7 * LETTER_VALUES[str[3]] +
        3 * LETTER_VALUES[str[5]] +
        1 * LETTER_VALUES[str[6]] +
        7 * LETTER_VALUES[str[7]] +
        3 * LETTER_VALUES[str[8]];
    sum %= 10;
    if (sum !== LETTER_VALUES[str[4]]) {
        return false;
    }
    return true;
}
/**
 * email, daniel@jursza.com
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function email(str) {
    return exports.patterns.EMAIL.test(str);
}
/**
 * guid, d020cc46-c999-4ba5-a7d0-8ddb13ade32c lub 8ddb13ade32c
 * 3 segment musi się zaczynać od cyfry 1-5
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function guid(str) {
    return guidshort(str) || guidlong(str);
}
/**
 * guidlong, d020cc46-c999-4ba5-a7d0-8ddb13ade32c
 * 3 segment musi się zaczynać od cyfry 1-5
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function guidlong(str) {
    return exports.patterns.GUID.test(str);
}
/**
 * guidshort, 8ddb13ade32c
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function guidshort(str) {
    return exports.patterns.GUID12.test(str);
}
/**
 * czy to liczba, same cyfry
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function numeric(str) {
    return exports.patterns.NUMERIC.test(str);
}
/**
 * 9 cyfrowy numer telefonu, same cyfry
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function phone9(str) {
    return exports.patterns.PHONE9.test(str);
}
/**
 * numer telefonu, same cyfry
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function phone(str) {
    return exports.patterns.PHONE.test(str);
}
const PASSPORT_WEIGHTS = [7, 3, 9, 1, 7, 3, 1, 7, 3];
/**
 * seria i numer paszportu
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
function passport(str) {
    if (str.length !== 9) {
        return false;
    }
    let sum = 0;
    for (let i = 0; i < str.length; i++) {
        const value = str[i] === '<' ? 0 : LETTER_VALUES[str[i]];
        if (value !== -1) {
            sum += value * PASSPORT_WEIGHTS[i];
        }
    }
    sum = sum % 10;
    return sum === 0;
}
const formatFunctions = {
    date,
    time,
    date_time,
    'date-time': date_time,
    nip,
    regon,
    regon9,
    regon14,
    kw,
    dowod,
    edowod,
    passport,
    guid,
    guidlong,
    guidshort,
    numeric,
    phone9,
    phone,
    email,
    iban,
    pesel,
    kod,
    kodpocztowy: kod,
    nrb: iban,
    uri,
    url,
    uuid,
    regex
};
/*
interface FormatFunctions {
  [key: string]: (str: string) => boolean;
}
*/
// formatPatterns.DATE.toLocaleString()
function checkFormat(format, data) {
    return checkFormatFunction(format)(data);
}
function checkFormatFunction(format) {
    return formatFunctions[format] || (() => true);
}
exports.default = formatFunctions;
//# sourceMappingURL=formatFunctions.js.map